import { ref } from "vue";

export const showLoadingIndicator = ref(false);
